module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/df6a71244d4727d19c5a78d71677d2a6.svg";